// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import {NewChatMenu} from '@app/features/app/components/layout/pioneer/ChatsHeading';
import styles from '@app/features/app/components/layout/pioneer/PioneerSidebar.module.css';
import * as RouterUtils from '@app/features/navigation/utils/RouterUtils';
import {CHATS_LABEL_DESCRIPTOR, YOUR_PROFILE_DESCRIPTOR} from '@app/features/tasks/utils/TaskMessageDescriptors';
import {Avatar} from '@app/features/ui/components/Avatar';
import Users from '@app/features/user/state/Users';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

/** Phone header for the Chats tab: the title, + to start a chat, and your picture for profile and settings. */
export const PioneerMobileChatsHeader = observer(({guildId}: {guildId: string}) => {
	const {i18n} = useLingui();
	const user = Users.currentUser;
	return (
		<header className={styles.mobileHeader} data-flx="app.pioneer.pioneer-mobile-chats-header.mobile-header">
			<h1 className={styles.mobileTitle} data-flx="app.pioneer.pioneer-mobile-chats-header.mobile-title">
				{i18n._(CHATS_LABEL_DESCRIPTOR)}
			</h1>
			<div className={styles.mobileActions} data-flx="app.pioneer.pioneer-mobile-chats-header.mobile-actions">
				<NewChatMenu
					guildId={guildId}
					className={styles.mobileIconButton}
					data-flx="app.pioneer.pioneer-mobile-chats-header.mobile-icon-button"
				/>
				{user && (
					<button
						type="button"
						className={styles.mobileIconButton}
						aria-label={i18n._(YOUR_PROFILE_DESCRIPTOR)}
						onClick={() => RouterUtils.transitionTo(Routes.YOU)}
						data-flx="app.pioneer.pioneer-mobile-chats-header.mobile-icon-button.transition-to"
					>
						<Avatar user={user} size={28} data-flx="app.pioneer.pioneer-mobile-chats-header.status-aware-avatar" />
					</button>
				)}
			</div>
		</header>
	);
});
